(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-instant-filter]').forEach(instant => {
      if (instant.dataset.ready) return;
      instant.dataset.ready = 'true';
      instant.closest('[data-instant-option]').hidden = false;
      instant.form.addEventListener('submit', () => {
        instant.form.action = instant.checked ? instant.dataset.addUrl : instant.dataset.removeUrl;
      });
    });
    scope.querySelectorAll('[data-native-sort]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    scope.querySelectorAll('[data-virtual-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const items = Array.from(catalog.querySelectorAll('[data-catalog-item]'));
      const grid = catalog.querySelector('[data-catalog-grid]');
      const categories = Array.from(catalog.querySelectorAll('[data-category-input]'));
      const categoryLinks = Array.from(catalog.querySelectorAll('[data-category-link]'));
      const available = catalog.querySelector('[data-available-input]');
      const sort = catalog.querySelector('[data-catalog-sort]');
      const count = catalog.querySelector('[data-catalog-count]');
      const active = catalog.querySelector('[data-catalog-active]');
      const empty = catalog.querySelector('[data-catalog-empty]');
      const collator = new Intl.Collator(document.documentElement.lang || 'en', { numeric: true, sensitivity: 'base' });
      const memberships = new Map(items.map(item => [item, (item.dataset.categories || item.dataset.category || '').split(',').filter(Boolean)]));
      const baseCounts = new Map(categories.map(input => [input.value, items.filter(item => memberships.get(item).includes(input.value)).length]));
      const aliases = {
        brewers: ['pour-over', 'espresso', 'coffee-makers', 'teapots'],
        grinders: ['grinders-scales'],
        scales: ['grinders-scales'],
        accessories: ['tools', 'drinkware'],
        equipment: ['pour-over', 'espresso', 'coffee-makers', 'teapots', 'kettles', 'grinders-scales', 'gift-sets'],
        'pour-over-brewers': ['pour-over'],
        'tea-pots': ['teapots'],
        syrup: ['syrups']
      };
      const readState = () => {
        const params = new URL(window.location.href).searchParams;
        const selected = [...params.getAll('type'), ...params.getAll('product_type')]
          .flatMap(value => value.split(','))
          .map(value => value.trim().toLowerCase().replaceAll('_', '-'))
          .flatMap(value => aliases[value] || [value]);
        categories.forEach(input => { input.checked = selected.includes(input.value); });
        available.checked = params.get('in_stock') === 'true';
        const requestedSort = params.get('sort_by');
        sort.value = Array.from(sort.options).some(option => option.value === requestedSort) ? requestedSort : 'featured';
      };
      const update = (writeUrl = true) => {
        const selected = categories.filter(input => input.checked).map(input => input.value);
        const sorted = [...items].sort((a, b) => {
          if (sort.value === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price) || collator.compare(a.dataset.title, b.dataset.title);
          if (sort.value === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price) || collator.compare(a.dataset.title, b.dataset.title);
          if (sort.value === 'title-ascending') return collator.compare(a.dataset.title, b.dataset.title);
          if (sort.value === 'title-descending') return collator.compare(b.dataset.title, a.dataset.title);
          if (sort.value === 'created-descending') return Number(b.dataset.created) - Number(a.dataset.created) || Number(a.dataset.originalOrder) - Number(b.dataset.originalOrder);
          return Number(a.dataset.originalOrder) - Number(b.dataset.originalOrder);
        });
        let visible = 0;
        const fragment = document.createDocumentFragment();
        sorted.forEach(item => {
          item.hidden = (selected.length > 0 && !memberships.get(item).some(value => selected.includes(value))) || (available.checked && item.dataset.available !== 'true');
          if (!item.hidden) visible += 1;
          fragment.appendChild(item);
        });
        grid.appendChild(fragment);
        count.textContent = count.dataset.countTemplate.replace('__COUNT__', visible);
        empty.hidden = visible !== 0;
        categories.forEach(input => {
          const label = input.closest('label');
          const number = items.filter(item => memberships.get(item).includes(input.value) && (!available.checked || item.dataset.available === 'true')).length;
          label.hidden = baseCounts.get(input.value) === 0 && !input.checked;
          input.disabled = number === 0 && !input.checked;
          label.querySelector('[data-category-count]').textContent = number;
        });
        categoryLinks.forEach(link => {
          const key = link.dataset.categoryLink;
          link.hidden = key !== '' && !baseCounts.get(key) && !selected.includes(key);
          const isCurrent = key === '' ? selected.length === 0 : selected.length === 1 && selected[0] === key;
          if (isCurrent) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
        });
        active.replaceChildren();
        [...categories.filter(input => input.checked), ...(available.checked ? [available] : [])].forEach(input => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = input.closest('label').querySelector('span').textContent;
          button.setAttribute('aria-label', catalog.dataset.removeTemplate.replace('__FILTER__', button.textContent));
          const cross = document.createElement('span');
          cross.setAttribute('aria-hidden', 'true');
          cross.textContent = '×';
          button.appendChild(cross);
          button.addEventListener('click', () => {
            input.checked = false;
            update();
            catalog.querySelector('.catalog-filter-toggle').focus();
          });
          active.appendChild(button);
        });
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.delete('product_type');
          url.searchParams.delete('type');
          url.searchParams.delete('page');
          if (selected.length) url.searchParams.set('type', selected.join(','));
          if (available.checked) url.searchParams.set('in_stock', 'true'); else url.searchParams.delete('in_stock');
          if (sort.value !== 'featured') url.searchParams.set('sort_by', sort.value); else url.searchParams.delete('sort_by');
          if (url.href !== window.location.href) window.history.pushState({}, '', url);
        }
      };
      categories.forEach(input => input.addEventListener('change', () => update()));
      available.addEventListener('change', () => update());
      sort.addEventListener('change', () => update());
      categoryLinks.forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        categories.forEach(input => { input.checked = input.value === link.dataset.categoryLink; });
        update();
      }));
      catalog.querySelectorAll('[data-clear-filters]').forEach(button => button.addEventListener('click', () => {
        categories.forEach(input => { input.checked = false; });
        available.checked = false;
        update();
      }));
      window.addEventListener('popstate', () => {
        if (!catalog.isConnected) return;
        readState();
        update(false);
      });
      readState();
      update(false);
    });
    scope.querySelectorAll('.catalog-filters').forEach(details => {
      if (details.dataset.dismissReady) return;
      details.dataset.dismissReady = 'true';
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); }
      });
      document.addEventListener('click', event => {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise()); else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
